import * as React from 'react'
import { Button, Intent } from '@blueprintjs/core'

interface Props {
  title: string
  editing: boolean
  onToggleEdit: () => void
  viewContent: React.ReactNode
  editContent: React.ReactNode
  'data-testid'?: string
}

export const ExpressListDrawerSection: React.FC<Props> = ({
  title,
  editing,
  onToggleEdit,
  viewContent,
  editContent,
  'data-testid': dataTestId
}) => {
  return (
    <section className="express-list-drawer-section" data-testid={dataTestId}>
      <div className="express-list-drawer-section-header">
        <h4>{title}</h4>
        <Button minimal intent={Intent.PRIMARY} onClick={onToggleEdit} data-testid={`${dataTestId}-toggle`}>
          {editing ? 'View' : 'Edit'}
        </Button>
      </div>
      <div className="express-list-drawer-section-body">{editing ? editContent : viewContent}</div>
      <hr />
    </section>
  )
}
